Date.prototype.format = function (demand) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(demand)) {
    demand = demand.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(demand)) {
      demand = demand.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return demand
}
import {
  showConfirmDialog
} from 'vant'
// 时间处理函数
export const formatDate = (time, formatString) => {
  const oldTime = time
  if (time) {
    if (typeof time === 'string') {
      time = Date.parse(time)
      if (!time) {
        if (Number(oldTime) && oldTime.length === 8) {
          time = oldTime
          time = Date.parse([time.slice(0, 4), time.slice(4, 6), time.slice(6, 8)].join('-'))
        } else {
          return oldTime
        }
      }
    }
    formatString = formatString || 'yyyy-MM-dd'
    return new Date(time).format(formatString)
  } else {
    return '-'
  }
};

// 价格处理
export const  formatNumber = (numStr) => {  
  const num = parseFloat(numStr.replace(/,/g, '')); // 尝试将字符串转换为数字  
  if (isNaN(num)) {  
    // 如果转换失败，返回原始字符串  
    return numStr;  
  }  
  
  if (num < 1000) {  
    // 如果数字小于1000，直接返回原值  
    return num.toFixed(2); // 保留两位小数  
  } else if (num < 1000000) {  
    // 如果数字在1000到10000之间，返回千位数+'K+'  
    return Math.floor(num / 1000) + 'K+'; // 保留一位小数  
  }else{  
    // 1万到1亿之间，返回万位数+'万'，保留一位小数  
    return  Math.floor(num / 10000 )+ 'W+' ;  
  } 
}  


// 判断是否登录
export const isLogin = (val, callback) => {
  // 跳转至观念页前向判断是否登录
  let loginInfo = localStorage.getItem('loginInfo')
  if (!loginInfo) {
    showConfirmDialog({
        title: '是否登录'
      })
      .then(() => {
        // on confirm
        // 传入路径时，存储路径
        if (val) {
          // console.log(val);
          sessionStorage.setItem('backPath', val)
        }
        window.location.href = "/login"
      })
      .catch(() => {
        // on cancel
        return
      });
  } else {
    // 用户已登录，执行后续操作
    if (callback && typeof callback === 'function') {
      callback();
    }
  }
}